var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.3 2C9.3 1.65522 9.16304 1.32456 8.91924 1.08076C8.67544 0.836964 8.34478 0.7 8 0.7C7.65522 0.7 7.32456 0.836964 7.08076 1.08076C6.83697 1.32456 6.7 1.65522 6.7 2V6.7H2C1.65522 6.7 1.32456 6.83697 1.08076 7.08076C0.836964 7.32456 0.7 7.65522 0.7 8C0.7 8.34478 0.836964 8.67544 1.08076 8.91924C1.32456 9.16304 1.65522 9.3 2 9.3H6.7V14C6.7 14.3448 6.83696 14.6754 7.08076 14.9192C7.32456 15.163 7.65522 15.3 8 15.3C8.34478 15.3 8.67544 15.163 8.91924 14.9192C9.16304 14.6754 9.3 14.3448 9.3 14V9.3H14C14.3448 9.3 14.6754 9.16304 14.9192 8.91924C15.163 8.67544 15.3 8.34478 15.3 8C15.3 7.65522 15.163 7.32456 14.9192 7.08076C14.6754 6.83696 14.3448 6.7 14 6.7H9.3V2Z",
    fill: "#2D6CDF",
    stroke: "#2D6CDF",
    strokeWidth: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.70fcb81758a8cd5f0dc3d5dd9ed0f378.svg";
export { ForwardRef as ReactComponent };